export default __webpack_public_path__ + "static/waitron_dashboard-ad128ad869362acb69e3ba9054a8c40b.png";